// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bm-crop-controls[data-v-8a0e6d8c]{border:1px solid #666;border-radius:8px;padding:10px;margin:12px 0}.bm-crop-controls label[data-v-8a0e6d8c]{display:block;margin:9px 0;font-size:12px}.bm-crop-controls input[type=range][data-v-8a0e6d8c]{display:block;width:100%}.bm-crop-controls small[data-v-8a0e6d8c]{display:block;margin-top:7px;color:#ccc}", ""]);
// Exports
module.exports = exports;
